import { ComponentElement } from '@locomotivemtl/component-manager';
import { Accordion } from '@scripts/components/Accordion';
import { Carousel } from '@scripts/components/Carousel';
import { Header } from '@scripts/components/Header';
import { Form } from '@scripts/components/Form';
import { HeroHome } from '@scripts/components/HeroHome';
import { InlineVideo } from '@scripts/components/InlineVideo';
import { HeroVisual } from '@scripts/components/HeroVisual';
import { ModalFeature } from '@scripts/components/ModalFeature';
import { Timelapse } from '@scripts/components/Timelapse';
import { JobsListing } from '@scripts/components/JobsListing';
import { AbstractMask } from '@scripts/components/AbstractMask';
import { Sun } from '@scripts/components/Sun';
import { FadeinText } from '@scripts/components/FadeinText';
import { SmoothProgress } from '@scripts/components/SmoothProgress';
import { Customization } from '@scripts/components/Customization';
import { Aside } from '@scripts/components/Aside';
import { ModalSaveBuild } from '@scripts/components/ModalSaveBuild';
import { Rail } from '@scripts/components/Rail';
import { ParallaxImage } from '@scripts/components/ParallaxImage';

export default async function () {
    if (!customElements.get('c-accordion'))
        customElements.define('c-accordion', ComponentElement(Accordion, 'Accordion'));
    if (!customElements.get('c-carousel'))
        customElements.define('c-carousel', ComponentElement(Carousel, 'Carousel'));
    if (!customElements.get('c-header'))
        customElements.define('c-header', ComponentElement(Header, 'Header'));
    if (!customElements.get('c-form'))
        customElements.define('c-form', ComponentElement(Form, 'Form'));
    if (!customElements.get('c-hero-home'))
        customElements.define('c-hero-home', ComponentElement(HeroHome, 'HeroHome'));
    if (!customElements.get('c-timelapse'))
        customElements.define('c-timelapse', ComponentElement(Timelapse, 'Timelapse'));
    if (!customElements.get('c-inline-video'))
        customElements.define('c-inline-video', ComponentElement(InlineVideo, 'InlineVideo'));
    if (!customElements.get('c-hero-visual'))
        customElements.define('c-hero-visual', ComponentElement(HeroVisual, 'HeroVisual'));
    if (!customElements.get('c-modal-feature'))
        customElements.define('c-modal-feature', ComponentElement(ModalFeature, 'ModalFeature'));
    if (!customElements.get('c-jobs-listing'))
        customElements.define('c-jobs-listing', ComponentElement(JobsListing, 'JobsListing'));
    if (!customElements.get('c-abstract-mask'))
        customElements.define('c-abstract-mask', ComponentElement(AbstractMask, 'AbstractMask'));
    if (!customElements.get('c-sun')) customElements.define('c-sun', ComponentElement(Sun, 'Sun'));
    if (!customElements.get('c-fadein-text'))
        customElements.define('c-fadein-text', ComponentElement(FadeinText, 'FadeinText'));
    if (!customElements.get('c-smooth-progress'))
        customElements.define(
            'c-smooth-progress',
            ComponentElement(SmoothProgress, 'SmoothProgress')
        );
    if (!customElements.get('c-customization'))
        customElements.define('c-customization', ComponentElement(Customization, 'Customization'));
    if (!customElements.get('c-aside'))
        customElements.define('c-aside', ComponentElement(Aside, 'Aside'));
    if (!customElements.get('c-modal-save-build'))
        customElements.define('c-modal-save-build', ComponentElement(ModalSaveBuild, 'ModalSaveBuild'));
    if (!customElements.get('c-rail'))
        customElements.define('c-rail', ComponentElement(Rail, 'Rail'));
    if (!customElements.get('c-parallax-image'))
        customElements.define('c-parallax-image', ComponentElement(ParallaxImage, 'ParallaxImage'));
}
